module.exports = __webpack_public_path__ + "assets/img/vip1.d26dae55.jpg";